import AV from 'leancloud-storage';
import { STUDY_REQUIREMENTS } from './studentService';
import * as XLSX from 'xlsx';
import moment from 'moment';
import dayjs from 'dayjs';
import { activityLogService } from './activityLogService';

// // Add the helper function for creating notes
// const createActionNote = (action, details = '') => {
//   const currentUser = authService.getCurrentUser();
//   const username = currentUser ? currentUser.get('username') : '未知用户';
//   const timestamp = new Date();

//   return {
//     content: `${username} ${action}${details ? `: ${details}` : ''}`,
//     date: timestamp.toISOString(),
//     createdAt: timestamp
//   };
// };

export const examService = {
  // Add exam types
  examTypes: [
    { key: '科目一', label: '科目一 (文明驾驶)' },
    { key: '科目二', label: '科目二 (场地驾驶)' },
    { key: '科目三', label: '科目三 (路考)' },
    { key: '科目四', label: '科目四 (安全文明)' },
  ],

  // Add student columns
  studentColumns: [
    { title: '档案号', dataIndex: 'fileId' },
    { title: '姓名', dataIndex: 'name' },
    { title: '身份证号', dataIndex: 'uniqueId' },
    { title: '电话', dataIndex: 'phone' },
    { title: '报名日期', dataIndex: 'signupDate' },
  ],

  // Add these helper functions at the top
  getExamRequirements: (examType) => {
    return {
      '科目一': {
        needsDocumented: true,
        needsStudyComplete: true,
        previousExam: null,
        waitDays: 0
      },
      '科目二': {
        needsStudyComplete: true,
        previousExam: '1',
        waitDays: 10
      },
      '科目三': {
        needsStudyComplete: true,
        previousExam: '1',
        waitDays: 30
      },
      '科目四': {
        previousExams: ['2', '3'], // Needs both 科目二 and 科目三
        waitDays: 0
      }
    }[examType];
  },

  // Get qualified students for exam
  async getQualifiedStudents({ exam, date, count }) {
    try {
      let query = new AV.Query('Student');
      
      console.log('========== Exam Requirements Check ==========');
      console.log('Exam Type:', exam);
      console.log('Current exam date:', date);
      
      // Basic condition
      query.equalTo('verified', true);
      query.equalTo('status', '正常');
      query.equalTo('documented', true);

      // Include all necessary fields
      query.include('receiptPic');
      query.include('tuitionReceipt');
      query.include('withdrawReceipt');

      // Handle different exam requirements
      switch(exam) {
        case '科目一':
          // Need subject1 study completed
          query.equalTo('subject1Completed', true);
          
          // For exam1, just check they haven't passed it yet
          const notExistsExam1 = new AV.Query('Student').doesNotExist('exam1');
          const failedExam1 = new AV.Query('Student')
            .exists('exam1')
            .equalTo('exam1.passed', false);
          query = AV.Query.and(query, AV.Query.or(notExistsExam1, failedExam1));
          break;

        case '科目二':
          // Need exam1 passed
          query.exists('exam1');
          query.equalTo('exam1.passed', true);
          
          // Need subject2 study completed
          query.equalTo('subject2Completed', true);
          
          // Calculate cutoff date (10 days before current exam date)
          const currentDate2 = new Date(date);
          const cutoffDate2 = new Date(currentDate2);
          cutoffDate2.setDate(cutoffDate2.getDate() - 10);
          const cutoffDateStr2 = cutoffDate2.toISOString().split('T')[0];
          
          console.log('Exam2 requirements check:', {
            examDate: currentDate2.toISOString().split('T')[0],
            cutoffDate: cutoffDateStr2,
            meaning: 'exam1.date must be before or on cutoff date',
            needsSubject2Completed: true
          });
          
          // Check exam1 date is at least 10 days before
          query.lessThanOrEqualTo('exam1.date', cutoffDateStr2);
          
          // Haven't passed exam2 yet
          const notExistsExam2 = new AV.Query('Student').doesNotExist('exam2');
          const failedExam2 = new AV.Query('Student')
            .exists('exam2')
            .equalTo('exam2.passed', false);
          query = AV.Query.and(query, AV.Query.or(notExistsExam2, failedExam2));
          break;

        case '科目三':
          // Need exam1 passed
          query.exists('exam1');
          query.equalTo('exam1.passed', true);
          
          // Need subject3 study completed
          query.equalTo('subject3Completed', true);
          
          // Calculate cutoff date (30 days before current exam date)
          const currentDate3 = new Date(date);
          const cutoffDate3 = new Date(currentDate3);
          cutoffDate3.setDate(cutoffDate3.getDate() - 30);
          const cutoffDateStr3 = cutoffDate3.toISOString().split('T')[0];
          
          console.log('Exam3 requirements check:', {
            examDate: currentDate3.toISOString().split('T')[0],
            cutoffDate: cutoffDateStr3,
            meaning: 'exam1.date must be before or on cutoff date',
            needsSubject3Completed: true
          });
          
          // Check exam1 date is at least 30 days before
          query.lessThanOrEqualTo('exam1.date', cutoffDateStr3);
          
          // Haven't passed exam3 yet
          const notExistsExam3 = new AV.Query('Student').doesNotExist('exam3');
          const failedExam3 = new AV.Query('Student')
            .exists('exam3')
            .equalTo('exam3.passed', false);
          query = AV.Query.and(query, AV.Query.or(notExistsExam3, failedExam3));
          break;

        case '科目四':
          // Need exam2 and exam3 passed
          query.exists('exam2');
          query.equalTo('exam2.passed', true);
          query.exists('exam3');
          query.equalTo('exam3.passed', true);
          
          // Need subject4 study completed
          query.equalTo('subject4Completed', true);
          
          // Haven't passed exam4 yet
          const notExistsExam4 = new AV.Query('Student').doesNotExist('exam4');
          const failedExam4 = new AV.Query('Student')
            .exists('exam4')
            .equalTo('exam4.passed', false);
          query = AV.Query.and(query, AV.Query.or(notExistsExam4, failedExam4));
          break;
        default:
          console.error('Unknown exam type:', exam);
          throw new Error('Unknown exam type');
      }

      // Add sorting
      query.addDescending('VIP');
      query.addAscending('signUpDate');

      // Execute query and log results
      const students = await query.find();
      console.log('Query results:', {
        totalFound: students.length,
        firstStudent: students[0] ? {
          name: students[0].get('name'),
          verified: students[0].get('verified'),
          VIP: students[0].get('VIP'),
          signUpDate: students[0].get('signUpDate'),
          subject1Completed: students[0].get('subject1Completed'),
          subject2Completed: students[0].get('subject2Completed'),
          subject3Completed: students[0].get('subject3Completed'),
          subject4Completed: students[0].get('subject4Completed'),
          exam1: students[0].get('exam1'),
          exam2: students[0].get('exam2'),
          exam3: students[0].get('exam3'),
          exam4: students[0].get('exam4'),
        } : null
      });

      return students.map(student => ({
        objectId: student.id,
        fileId: student.get('fileId'),
        name: student.get('name'),
        uniqueId: student.get('uniqueId'),
        phone: student.get('phone'),
        signUpDate: student.get('signUpDate'),
        VIP: student.get('VIP'),
        address: student.get('address'),
        tuitionFee: student.get('tuitionFee'),
        referrer: student.get('referrer'),
        notes: student.get('notes'),
        // Additional fields needed for StudentDetail
        ethnicity: student.get('ethnicity'),
        birthday: student.get('birthday'),
        local: student.get('local'),
        verified: student.get('verified'),
        documented: student.get('documented'),
        interviewed: student.get('interviewed'),
        status: student.get('status'),
        transferred: student.get('transferred'),
        paid: student.get('paid'),
        paymentMethod: student.get('paymentMethod'),
        receiptNumber: student.get('receiptNumber'),
        receiptPic: student.get('receiptPic'),
        tuitionReceipt: student.get('tuitionReceipt'),
        gender: student.get('gender'),
        exams: student.get('exams'),
        exam1: student.get('exam1'),
        exam2: student.get('exam2'),
        exam3: student.get('exam3'),
        exam4: student.get('exam4'),
        studyProgress: student.get('studyProgress'),
        withdrawDate: student.get('withdrawDate'),
        withdrawReason: student.get('withdrawReason'),
        withdrawReceipt: student.get('withdrawReceipt')
      }));
    } catch (error) {
      console.error('Get qualified students error:', error);
      throw error;
    }
  },

  async submitExamBooking(bookingData, selectedStudents) {
    try {
      const ExamBooking = AV.Object.extend('ExamBooking');
      const booking = new ExamBooking();

      // Set basic booking info
      booking.set('date', new Date(bookingData.date));
      booking.set('examType', bookingData.exam);
      booking.set('examiner', bookingData.examiner);
      booking.set('status', 'pending');
      booking.set('createdBy', AV.User.current());
      
      // Set students info
      const students = selectedStudents.map(student => ({
        studentId: student.objectId,
        name: student.name,
        fileId: student.fileId,
        uniqueId: student.uniqueId,
        phone: student.phone,
        result: null,
        status: 'pending'
      }));
      booking.set('students', students);
      
      // Set counts
      booking.set('totalCount', students.length);
      booking.set('completedCount', 0);
      booking.set('passedCount', 0);

      // Save booking
      const savedBooking = await booking.save(null, { useMasterKey: true });
      
      await activityLogService.logActivity(
        '创建考试',
        `创建${bookingData.exam}考试，考官: ${bookingData.examiner}，考试日期: ${bookingData.date}`
      );
      
      return savedBooking.toJSON();
    } catch (error) {
      console.error('Submit exam booking error:', error);
      throw error;
    }
  },

  async submitExamResults(examId, results) {
    try {
      const examQuery = new AV.Query('ExamBooking');
      const exam = await examQuery.get(examId);
      
      exam.set('results', results);
      exam.set('examStatus', '已总结');
      await exam.save();

      // Update student exam records
      const examType = exam.get('exam');
      const examDate = exam.get('date');
      
      const promises = Object.entries(results).map(async ([studentId, result]) => {
        const ExamClass = {
          '科目一': 'Subject1Exam',
          '科目二': 'Subject2Exam',
          '科目三': 'Subject3Exam',
          '科目四': 'Subject4Exam'
        }[examType];

        const examRecord = new AV.Object(ExamClass);
        const studentPointer = AV.Object.createWithoutData('Student', studentId);

        examRecord.set('student', studentPointer);
        examRecord.set('examDate', examDate);
        examRecord.set('result', result);
        examRecord.set('examiner', exam.get('examiner'));
        examRecord.set('bookingNumber', exam.get('bookingNumber'));

        if (result === 'passed') {
          const studentQuery = new AV.Query('Student');
          const student = await studentQuery.get(studentId);
          const passDateField = {
            '科目一': 'subject1PassedAt',
            '科目二': 'subject2PassedAt',
            '科目三': 'subject3PassedAt',
            '科目四': 'subject4PassedAt'
          }[examType];
          
          student.set(passDateField, new Date(examDate));
          await student.save(null, { useMasterKey: true });
        }

        return examRecord.save();
      });

      await Promise.all(promises);

      await activityLogService.logActivity(
        '提交考试结果',
        `提交${examType}考试结果，通过: ${exam.get('passedCount')}人，总计: ${results.length}人`
      );

      return true;
    } catch (error) {
      console.error('Submit exam results error:', error);
      throw error;
    }
  },

  // Get exam records for a student
  async getStudentExams(studentId, examType) {
    try {
      const ExamClass = {
        '科目一': 'Subject1Exam',
        '科目二': 'Subject2Exam',
        '科目三': 'Subject3Exam',
        '科目四': 'Subject4Exam'
      }[examType];

      const query = new AV.Query(ExamClass);
      const studentPointer = AV.Object.createWithoutData('Student', studentId);
      query.equalTo('student', studentPointer);
      query.addDescending('examDate');
      
      const exams = await query.find();
      return exams.map(exam => ({
        examDate: exam.get('examDate'),
        result: exam.get('result'),
        examiner: exam.get('examiner'),
        bookingNumber: exam.get('bookingNumber')
      }));
    } catch (error) {
      console.error('Get student exams error:', error);
      throw error;
    }
  },

  async getAllExams() {
    try {
      const query = new AV.Query('ExamBooking');
      query.include('createdBy');
      query.descending('date');
      query.limit(1000); // Adjust limit as needed
      
      const results = await query.find();
      return results.map(exam => ({
        objectId: exam.id,
        date: exam.get('date'),
        examType: exam.get('examType'),
        examiner: exam.get('examiner'),
        status: exam.get('status'),
        students: exam.get('students'),
        createdBy: exam.get('createdBy')?.get('username'),
        createdAt: exam.get('createdAt')
      }));
    } catch (error) {
      console.error('Get all exams error:', error);
      throw error;
    }
  },

  async getExamById(examId) {
    try {
      const query = new AV.Query('ExamBooking');
      query.include('createdBy');
      const exam = await query.get(examId);
      
      // Fetch complete student details for each student in the exam
      const studentPromises = (exam.get('students') || []).map(async (examStudent) => {
        const studentQuery = new AV.Query('Student');
        // Include all necessary fields like in searchStudent
        studentQuery.include('receiptPic');
        studentQuery.include('tuitionReceipt');
        studentQuery.include('withdrawReceipt');
        
        try {
          const student = await studentQuery.get(examStudent.studentId);
          return {
            objectId: student.id,
            fileId: student.get('fileId'),
            name: student.get('name'),
            uniqueId: student.get('uniqueId'),
            phone: student.get('phone'),
            signUpDate: student.get('signUpDate'),
            VIP: student.get('VIP'),
            address: student.get('address'),
            tuitionFee: student.get('tuitionFee'),
            referrer: student.get('referrer'),
            notes: student.get('notes'),
            // Additional fields needed for StudentDetail
            ethnicity: student.get('ethnicity'),
            birthday: student.get('birthday'),
            local: student.get('local'),
            verified: student.get('verified'),
            documented: student.get('documented'),
            interviewed: student.get('interviewed'),
            status: student.get('status'),
            transferred: student.get('transferred'),
            paid: student.get('paid'),
            paymentMethod: student.get('paymentMethod'),
            receiptNumber: student.get('receiptNumber'),
            receiptPic: student.get('receiptPic'),
            tuitionReceipt: student.get('tuitionReceipt'),
            gender: student.get('gender'),
            exams: student.get('exams'),
            exam1: student.get('exam1'),
            exam2: student.get('exam2'),
            exam3: student.get('exam3'),
            exam4: student.get('exam4'),
            studyProgress: student.get('studyProgress'),
            withdrawDate: student.get('withdrawDate'),
            withdrawReason: student.get('withdrawReason'),
            withdrawReceipt: student.get('withdrawReceipt'),
            // Add exam booking specific status
            examStatus: examStudent.status || 'pending'
          };
        } catch (error) {
          console.error(`Failed to fetch student ${examStudent.studentId}:`, error);
          return examStudent;
        }
      });

      const students = await Promise.all(studentPromises);
      
      return {
        objectId: exam.id,
        date: exam.get('date'),
        examType: exam.get('examType'),
        examiner: exam.get('examiner'),
        status: exam.get('status'),
        students: students,
        createdBy: exam.get('createdBy')?.get('username'),
        createdAt: exam.get('createdAt'),
        totalCount: exam.get('totalCount'),
        completedCount: exam.get('completedCount'),
        passedCount: exam.get('passedCount')
      };
    } catch (error) {
      console.error('Get exam by id error:', error);
      throw error;
    }
  },

  async getUnverifiedExams(dateRange) {
    try {
      const query = new AV.Query('ExamBooking');
      query.equalTo('examStatus', '已考试');
      query.notEqualTo('results', null);
      
      if (dateRange) {
        const [startDate, endDate] = dateRange;
        query.greaterThanOrEqualTo('date', startDate.startOf('day').toDate());
        query.lessThanOrEqualTo('date', endDate.endOf('day').toDate());
      }

      query.descending('date');
      query.include('students');
      
      const exams = await query.find();
      return exams.map(exam => ({
        objectId: exam.id,
        date: exam.get('date'),
        exam: exam.get('exam'),
        examiner: exam.get('examiner'),
        studentCount: exam.get('studentCount'),
        students: exam.get('students'),
        examStatus: exam.get('examStatus'),
        bookingNumber: exam.get('bookingNumber')
      }));
    } catch (error) {
      console.error('Get unverified exams error:', error);
      throw error;
    }
  },

  // Get students with incomplete study hours for a subject
  async getIncompleteStudents(subject) {
    try {
      const query = new AV.Query('Student');
      
      console.log('Querying for subject:', subject);
      
      // Basic filters
      query.equalTo('status', '正常');
      query.equalTo('verified', true);

      // Debug: Check if we can find the student with this ID directly
      const debugStudentId = "232332200104260016"; // The uniqueId of the student in question
      const debugQuery = new AV.Query('Student');
      debugQuery.equalTo('uniqueId', debugStudentId);
      const debugStudent = await debugQuery.first();
      if (debugStudent) {
        console.log('DEBUG: Found the student with uniqueId', debugStudentId);
        console.log('DEBUG: Student status:', debugStudent.get('status'));
        console.log('DEBUG: Student verified:', debugStudent.get('verified'));
        console.log('DEBUG: Student has exams array:', !!debugStudent.get('exams'));
        console.log('DEBUG: Student subject1Completed:', debugStudent.get('subject1Completed'));
      } else {
        console.log('DEBUG: Could not find student with uniqueId', debugStudentId);
      }

      // Convert Chinese subject number to Arabic numeral
      const subjectMap = {
        '科目一': '1',
        '科目二': '2',
        '科目三': '3',
        '科目四': '4'
      };
      
      const subjectNumber = subjectMap[subject];
      const examField = `exam${subjectNumber}`;
      const subjectField = `subject${subjectNumber}`;
      const completedField = `subject${subjectNumber}Completed`;
      
      // Create three queries:
      // 1. Students who failed the exam
      const notPassedQuery = new AV.Query('Student');
      notPassedQuery.equalTo(`${examField}.passed`, false);
      
      // 2. Students who haven't taken the exam
      const noExamQuery = new AV.Query('Student');
      noExamQuery.doesNotExist(examField);

      // 3. Students who haven't completed the subject hours
      const notCompletedQuery = new AV.Query('Student');
      notCompletedQuery.equalTo(completedField, false);
      
      // 4. Students who don't have the completed field at all
      const noCompletedFieldQuery = new AV.Query('Student');
      noCompletedFieldQuery.doesNotExist(completedField);

      // Combine exam queries with OR
      const examQuery = AV.Query.or(notPassedQuery, noExamQuery);
      
      // Combine completion queries with OR
      const completionQuery = AV.Query.or(notCompletedQuery, noCompletedFieldQuery);
      
      // Combine all conditions with AND
      const finalQuery = AV.Query.and(
        query,  // Basic filters (status and verified)
        examQuery,  // Exam status
        completionQuery  // Subject completion status
      );

      // Remove the limit to show all students
      // finalQuery.limit(100); // Increase from 30 to 100 to make sure we don't miss students
      finalQuery.addAscending('createdAt');

      const students = await finalQuery.find();
      console.log('Query results total count:', students.length);
      
      // Debug: Check if our specific student is in the results
      const foundSpecificStudent = students.some(student => student.get('uniqueId') === debugStudentId);
      console.log('DEBUG: Found specific student in results:', foundSpecificStudent);
      
      // Debug logging
      if (students.length > 0) {
        const firstStudent = students[0];
        console.log('Sample student data:', {
          name: firstStudent.get('name'),
          uniqueId: firstStudent.get('uniqueId'),
          status: firstStudent.get('status'),
          verified: firstStudent.get('verified'),
          completed: firstStudent.get(completedField),
          progress: firstStudent.get(subjectField),
          examStatus: firstStudent.get(examField)
        });
      }

      return students.map(student => {
        // Default progress template based on subject
        const defaultProgress = {
          minutes: 0,
          ...(subject === '科目二' || subject === '科目三' ? { kilometers: 0 } : {})
        };

        // Get actual progress or use default
        const subjectProgress = student.get(subjectField) || defaultProgress;
        const requirements = STUDY_REQUIREMENTS[subject];
        
        return {
          objectId: student.id,
          fileId: student.get('fileId'),
          name: student.get('name'),
          uniqueId: student.get('uniqueId'),
          phone: student.get('phone'),
          studyProgress: subjectProgress,
          requirements: requirements,
          examStatus: student.get(examField),
          studyHours: subject === '科目二' || subject === '科目三' 
            ? `${Math.floor(subjectProgress.minutes/60)}小时 ${subjectProgress.kilometers}公里`
            : `${Math.floor(subjectProgress.minutes/60)}小时`
        };
      });
    } catch (error) {
      console.error('Get incomplete students error:', error);
      console.error('Error details:', {
        message: error.message,
        code: error.code,
        stack: error.stack
      });
      throw error;
    }
  },

  // Search student by ID/name/phone
  async searchStudent(searchValue) {
    try {
      console.log('Searching for student with value:', searchValue);
      
      // Create three queries for different search criteria
      const nameQuery = new AV.Query('Student')
        .startsWith('name', searchValue)
        .equalTo('status', '正常');
        
      // Add exact name match query
      const exactNameQuery = new AV.Query('Student')
        .equalTo('name', searchValue)
        .equalTo('status', '正常');
      
      const idQuery = new AV.Query('Student')
        .contains('uniqueId', searchValue)
        .equalTo('status', '正常');
      
      const phoneQuery = new AV.Query('Student')
        .contains('phone', searchValue)
        .equalTo('status', '正常');
        
      // Add fileId query
      const fileIdQuery = new AV.Query('Student')
        .contains('fileId', searchValue)
        .equalTo('status', '正常');

      // Debug - run individual queries to see which ones return results
      console.log('Checking individual search methods:');
      const nameResults = await nameQuery.find();
      console.log(`- Name search (startsWith) found ${nameResults.length} results`);
      if (nameResults.length > 0) {
        console.log('  First name result:', nameResults[0].get('name'));
      }
      
      const exactNameResults = await exactNameQuery.find();
      console.log(`- Exact name search found ${exactNameResults.length} results`);
      if (exactNameResults.length > 0) {
        console.log('  First exact name result:', exactNameResults[0].get('name'));
      }
      
      const idResults = await idQuery.find();
      console.log(`- ID search found ${idResults.length} results`);
      
      const phoneResults = await phoneQuery.find();
      console.log(`- Phone search found ${phoneResults.length} results`);
      
      const fileIdResults = await fileIdQuery.find();
      console.log(`- FileID search found ${fileIdResults.length} results`);

      // Combine queries with OR
      const query = AV.Query.or(nameQuery, exactNameQuery, idQuery, phoneQuery, fileIdQuery);
      
      // Add sorting
      query.addDescending('VIP');
      query.addAscending('signUpDate');
      
      // Include all necessary fields
      query.include('receiptPic');
      query.include('tuitionReceipt');
      query.include('withdrawReceipt');
      
      // Get all matching students
      const students = await query.find();
      console.log('Search found', students.length, 'students in total after combining all search methods');
      
      // Debug specific student
      if (searchValue === "宁佑铭" || searchValue === "232332200104260016" || searchValue === "666") {
        console.log('Debug search for target student:', students.length > 0);
        if (students.length > 0) {
          console.log('Debug found student:', {
            name: students[0].get('name'),
            uniqueId: students[0].get('uniqueId'),
            fileId: students[0].get('fileId'),
            status: students[0].get('status'),
            verified: students[0].get('verified'),
            subject1Completed: students[0].get('subject1Completed')
          });
        }
      }
      
      // Map results to include all necessary fields
      return students.map(student => ({
        objectId: student.id,
        fileId: student.get('fileId'),
        name: student.get('name'),
        uniqueId: student.get('uniqueId'),
        phone: student.get('phone'),
        signUpDate: student.get('signUpDate'),
        VIP: student.get('VIP'),
        address: student.get('address'),
        tuitionFee: student.get('tuitionFee'),
        referrer: student.get('referrer'),
        notes: student.get('notes'),
        // Additional fields needed for StudentDetail
        ethnicity: student.get('ethnicity'),
        birthday: student.get('birthday'),
        local: student.get('local'),
        verified: student.get('verified'),
        documented: student.get('documented'),
        interviewed: student.get('interviewed'),
        status: student.get('status'),
        transferred: student.get('transferred'),
        paid: student.get('paid'),
        paymentMethod: student.get('paymentMethod'),
        receiptNumber: student.get('receiptNumber'),
        receiptPic: student.get('receiptPic'),
        tuitionReceipt: student.get('tuitionReceipt'),
        gender: student.get('gender'),
        exams: student.get('exams'),
        exam1: student.get('exam1'),
        exam2: student.get('exam2'),
        exam3: student.get('exam3'),
        exam4: student.get('exam4'),
        studyProgress: student.get('studyProgress'),
        withdrawDate: student.get('withdrawDate'),
        withdrawReason: student.get('withdrawReason'),
        withdrawReceipt: student.get('withdrawReceipt')
      }));
    } catch (error) {
      console.error('Search student error:', error);
      throw error;
    }
  },

  // Update study hours for multiple students
  async updateStudyHours(studentIds, subject, minutes, kilometers = 0) {
    try {
      // Convert Chinese subject number to Arabic numeral
      const subjectMap = {
        '科目一': '1',
        '科目二': '2',
        '科目三': '3',
        '科目四': '4'
      };
      
      const subjectNumber = subjectMap[subject];
      const subjectField = `subject${subjectNumber}`; // Now using numeric field name
      const completedField = `subject${subjectNumber}Completed`;

      const promises = studentIds.map(async studentId => {
        const student = AV.Object.createWithoutData('Student', studentId);
        
        // Get current progress
        const currentStudent = await new AV.Query('Student').get(studentId);
        const currentProgress = currentStudent.get(subjectField) || {
          minutes: 0,
          ...(subject === '科目二' || subject === '科目三' ? { kilometers: 0 } : {})
        };

        // Calculate new values
        const newProgress = {
          minutes: currentProgress.minutes + minutes,
          ...(subject === '科目二' || subject === '科目三' 
            ? { kilometers: (currentProgress.kilometers || 0) + kilometers }
            : {})
        };

        // Check if requirements are met
        const requirements = STUDY_REQUIREMENTS[subject];
        const completed = 
          newProgress.minutes >= requirements.minutes &&
          (!requirements.kilometers || newProgress.kilometers >= requirements.kilometers);

        // Update progress and completion flag
        student.set(subjectField, newProgress);
        student.set(completedField, completed);

        return student.save(null, { useMasterKey: true });
      });

      await Promise.all(promises);
    } catch (error) {
      console.error('Update study hours error:', error);
      throw error;
    }
  },

  // Save study progress list
  async saveStudyProgressList(subject, students) {
    try {
      const StudyProgressList = AV.Object.extend('StudyProgressList');
      const list = new StudyProgressList();
      
      list.set('subject', subject);
      list.set('students', students.map(s => ({
        objectId: s.objectId,
        name: s.name,
        fileId: s.fileId,
        uniqueId: s.uniqueId,
        phone: s.phone,
        currentHours: s.studyHours
      })));
      list.set('status', 'pending');
      list.set('createdBy', AV.User.current());
      
      await list.save();
      return list.toJSON();
    } catch (error) {
      console.error('Save study progress list error:', error);
      throw error;
    }
  },

  // Get saved study progress lists
  async getSavedStudyProgressLists() {
    try {
      const query = new AV.Query('StudyProgressList');
      query.equalTo('status', 'pending');
      query.addDescending('createdAt');
      query.include('createdBy');
      
      const lists = await query.find();
      return lists.map(list => ({
        objectId: list.id,
        subject: list.get('subject'),
        students: list.get('students'),
        status: list.get('status'),
        createdAt: list.get('createdAt'),
        createdBy: list.get('createdBy')?.get('username')
      }));
    } catch (error) {
      console.error('Get saved lists error:', error);
      throw error;
    }
  },

  // Complete a study progress list
  async completeStudyProgressList(listId, hours) {
    try {
      const list = await new AV.Query('StudyProgressList').get(listId);
      const students = list.get('students');
      const subject = list.get('subject');

      // Update hours for all students in the list
      await this.updateStudyHours(
        students.map(s => s.objectId),
        subject,
        hours
      );

      // Mark list as completed
      list.set('status', 'completed');
      list.set('completedAt', new Date());
      list.set('hoursAdded', hours);
      await list.save();

      return list.toJSON();
    } catch (error) {
      console.error('Complete study progress list error:', error);
      throw error;
    }
  },

  // Update exam result
  async updateExamResult(studentId, examType, result) {
    try {
      const student = AV.Object.createWithoutData('Student', studentId);
      const examNumber = examType.charAt(2);
      
      // Create new exam record
      const examRecord = {
        passed: result.passed,
        date: result.date,
        examiner: result.examiner,
        createdAt: new Date().toISOString()
      };

      // Update both the exam array and the specific exam field
      const currentStudent = await new AV.Query('Student').get(studentId);
      const exams = currentStudent.get('exams') || [];
      
      // Add to exams array
      exams.push({
        examType: examNumber,
        ...examRecord
      });
      student.set('exams', exams);

      // Update specific exam field
      student.set(`exam${examNumber}`, examRecord);

      // Create note with proper format
      const currentUser = AV.User.current();
      const username = currentUser ? currentUser.get('username') : '未知用户';
      const note = {
        content: `${username} 更新了 ${examType}考试结果 为 ${result.passed ? '通过' : '未通过'}`,
        date: new Date().toISOString()
      };

      const existingNotes = currentStudent.get('notes') || [];
      student.set('notes', [...existingNotes, note]);

      await student.save(null, { useMasterKey: true });
      return student;
    } catch (error) {
      console.error('Update exam result error:', error);
      throw error;
    }
  },

  // Add the export function as a method of examService
  exportBookingToExcel(students, bookingData) {
    try {
      // Format date
      const dateStr = moment(bookingData.date).format('YYYY-MM-DD');
      
      // Create title
      const fileName = `${dateStr}${bookingData.exam}约考名单_${bookingData.examiner || '未定'}`;
      
      // Create header information
      const headerInfo = [
        [`考试日期：${dateStr}`],
        [`考试科目：${bookingData.exam}`],
        [`考官：${bookingData.examiner || '未定'}`],
        [`考试人数：${students.length}人`],
        [], // Empty row for spacing
      ];

      // Create column headers
      const headers = [
        '序号',
        '备注',
        '档案号',
        '报名日期',
        '姓名',
        '身份证号',
        '电话',
        '推荐人',
        '学费',
        '地址'
      ];

      // Transform student data
      const data = students.map((student, index) => [
        index + 1, // 序号
        (student.notes || [])  // 备注 - combine all notes
          .map(note => `${moment(note.date).format('YYYY-MM-DD HH:mm')} ${note.content}`)
          .join('\n'),
        student.fileId || '', // 档案号
        student.signUpDate ? moment(student.signUpDate).format('YYYY-MM-DD') : '', // 报名日期
        student.name || '', // 姓名
        student.uniqueId || '', // 身份证号
        student.phone || '', // 电话
        student.referrer || '', // 推荐人
        student.tuitionFee || '', // 学费
        student.address || '' // 地址
      ]);

      // Combine all rows
      const allRows = [...headerInfo, headers, ...data];

      // Create workbook and worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(allRows);

      // Set column widths
      const colWidths = [
        { wch: 6 },  // 序号
        { wch: 40 }, // 备注
        { wch: 12 }, // 档案号
        { wch: 12 }, // 报名日期
        { wch: 8 },  // 姓名
        { wch: 20 }, // 身份证号
        { wch: 12 }, // 电话
        { wch: 10 }, // 推荐人
        { wch: 8 },  // 学费
        { wch: 30 }  // 地址
      ];
      ws['!cols'] = colWidths;

      // Set row heights for header info
      ws['!rows'] = headerInfo.map(() => ({ hpt: 25 }));

      // Style the cells
      for (let i = 0; i < headerInfo.length; i++) {
        const cellRef = XLSX.utils.encode_cell({ r: i, c: 0 });
        if (!ws[cellRef]) continue;
        ws[cellRef].s = {
          font: { bold: true, sz: 12 },
          alignment: { horizontal: 'left', vertical: 'center' }
        };
      }

      // Style the column headers
      const headerRowIndex = headerInfo.length;
      headers.forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({ r: headerRowIndex, c: colIndex });
        if (!ws[cellRef]) return;
        ws[cellRef].s = {
          font: { bold: true, sz: 11 },
          alignment: { horizontal: 'center', vertical: 'center' },
          fill: { fgColor: { rgb: "EFEFEF" } }
        };
      });

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, '约考名单');

      // Save file
      XLSX.writeFile(wb, `${fileName}.xlsx`);

    } catch (error) {
      console.error('Export to Excel error:', error);
      throw error;
    }
  },

  // Add this helper function to check qualification
  checkStudentQualification(student, examType, examDate) {
    try {
      const errors = [];

      // Basic conditions
      if (!student.verified) {
        errors.push('学员未审核');
      }
      if (student.status !== '正常') {
        errors.push('学员状态异常');
      }
      if (!student.documented) {
        errors.push('学员未审档');
      }

      // Specific exam requirements
      switch(examType) {
        case '科目一':
          if (!student.subject1Completed) {
            errors.push('科目一学时未完成');
          }
          if (student.exam1?.passed) {
            errors.push('已通过科目一考试');
          }
          break;

        case '科目二':
          if (!student.exam1?.passed) {
            errors.push('未通过科目一考试');
          }
          if (!student.subject2Completed) {
            errors.push('科目二学时未完成');
          }
          if (student.exam2?.passed) {
            errors.push('已通过科目二考试');
          }
          // Check 10-day waiting period
          if (student.exam1?.date) {
            const cutoffDate = new Date(examDate);
            cutoffDate.setDate(cutoffDate.getDate() - 10);
            const exam1Date = new Date(student.exam1.date);
            if (exam1Date > cutoffDate) {
              errors.push('科目一考试通过未满10天');
            }
          }
          break;

        case '科目三':
          if (!student.exam1?.passed) {
            errors.push('未通过科目一考试');
          }
          if (!student.subject3Completed) {
            errors.push('科目三学时未完成');
          }
          if (student.exam3?.passed) {
            errors.push('已通过科目三考试');
          }
          // Check 30-day waiting period
          if (student.exam1?.date) {
            const cutoffDate = new Date(examDate);
            cutoffDate.setDate(cutoffDate.getDate() - 30);
            const exam1Date = new Date(student.exam1.date);
            if (exam1Date > cutoffDate) {
              errors.push('科目一考试通过未满30天');
            }
          }
          break;

        case '科目四':
          if (!student.exam2?.passed) {
            errors.push('未通过科目二考试');
          }
          if (!student.exam3?.passed) {
            errors.push('未通过科目三考试');
          }
          if (!student.subject4Completed) {
            errors.push('科目四学时未完成');
          }
          if (student.exam4?.passed) {
            errors.push('已通过科目四考试');
          }
          break;

        default:
          errors.push('未知的考试类型');
          break;
      }

      return {
        qualified: errors.length === 0,
        errors
      };
    } catch (error) {
      console.error('Check qualification error:', error);
      throw error;
    }
  },

  // Add this method to examService
  async parseTextToStudents(file, onProgress) {
    try {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onload = async (e) => {
          try {
            // Split text file content by newlines and filter empty lines
            const uniqueIds = e.target.result
              .split('\n')
              .map(id => id.trim())
              .filter(id => id);

            console.log('Parsed IDs from file:', uniqueIds);
            
            // Process in batches of 5
            const batchSize = 5;
            const results = [];
            
            for (let i = 0; i < uniqueIds.length; i += batchSize) {
              // Get current batch
              const batch = uniqueIds.slice(i, i + batchSize);
              
              // Update progress
              onProgress((i / uniqueIds.length) * 100);
              
              // Process batch
              const batchPromises = batch.map(id => {
                const query = new AV.Query('Student');
                query.equalTo('uniqueId', id);
                query.equalTo('status', '正常');
                query.include('receiptPic');
                query.include('tuitionReceipt');
                query.include('withdrawReceipt');
                return query.first();
              });

              // Wait between batches to avoid rate limiting
              if (i > 0) {
                await new Promise(resolve => setTimeout(resolve, 1000));
              }

              const batchResults = await Promise.all(batchPromises);
              results.push(...batchResults);
            }
            
            // Update progress to 100%
            onProgress(100);
            
            // Filter and map results
            const foundStudents = results
              .filter(student => student)
              .map(student => ({
                objectId: student.id,
                fileId: student.get('fileId'),
                name: student.get('name'),
                uniqueId: student.get('uniqueId'),
                phone: student.get('phone'),
                signUpDate: student.get('signUpDate'),
                VIP: student.get('VIP'),
                address: student.get('address'),
                tuitionFee: student.get('tuitionFee'),
                referrer: student.get('referrer'),
                notes: student.get('notes'),
                // Additional fields needed for qualification check
                verified: student.get('verified'),
                documented: student.get('documented'),
                interviewed: student.get('interviewed'),
                status: student.get('status'),
                subject1Completed: student.get('subject1Completed'),
                subject2Completed: student.get('subject2Completed'),
                subject3Completed: student.get('subject3Completed'),
                subject4Completed: student.get('subject4Completed'),
                exam1: student.get('exam1'),
                exam2: student.get('exam2'),
                exam3: student.get('exam3'),
                exam4: student.get('exam4')
              }));

            resolve(foundStudents);
          } catch (error) {
            reject(error);
          }
        };

        reader.onerror = () => reject(new Error('File reading failed'));
        reader.readAsText(file);
      });
    } catch (error) {
      console.error('Parse text to students error:', error);
      throw error;
    }
  },

  async removeStudentFromExam(examId, studentId, note) {
    try {
      const exam = await new AV.Query('ExamBooking').get(examId);
      const students = exam.get('students');
      
      // Find student and add note
      const studentIndex = students.findIndex(s => s.objectId === studentId);
      if (studentIndex !== -1) {
        if (!students[studentIndex].notes) {
          students[studentIndex].notes = [];
        }
        students[studentIndex].notes.push(note);
        students[studentIndex].status = 'cancelled';
        
        // Update exam
        exam.set('students', students);
        await exam.save(null, { useMasterKey: true });
      }
      
      return exam.toJSON();
    } catch (error) {
      console.error('Remove student error:', error);
      throw error;
    }
  },

  async editResult(examId, studentId, result) {
    try {
      const examQuery = new AV.Query('ExamBooking');
      const exam = await examQuery.get(examId);
      
      const students = exam.get('students');
      let passedCount = exam.get('passedCount') || 0;
      
      const updatedStudents = students.map(student => {
        if (student.studentId === studentId) {
          if (student.result === 'passed') passedCount--;
          if (result === 'passed') passedCount++;
          
          return {
            ...student,
            result,
            status: result
          };
        }
        return student;
      });

      exam.set('students', updatedStudents);
      exam.set('passedCount', passedCount);

      // Update student record
      const studentQuery = new AV.Query('Student');
      const studentObj = await studentQuery.get(studentId);
      
      const examType = exam.get('examType');
      const examNumber = examType.slice(-1);
      const examField = `exam${examNumber}`;
      const examCompletedField = `subject${examNumber}Completed`;
      
      studentObj.set(examField, {
        passed: result === 'passed',
        date: dayjs(exam.get('date')).format('YYYY-MM-DD')
      });
      
      studentObj.set(examCompletedField, result === 'passed');

      // Update student status to graduated if passed 科目四
      if (examType === '科目四' && result === 'passed') {
        studentObj.set('status', '已毕业');
        studentObj.set('graduateDate', new Date());
      }

      // Add note
      const currentUser = AV.User.current();
      const username = currentUser ? currentUser.get('username') : '未知用户';
      const resultText = {
        'passed': '通过',
        'failed': '未通过',
        'absent': '缺考'
      }[result] || result;

      const notes = [
        {
          content: `${username} 更新了 ${examType}考试结果 为 「${resultText}」`,
          date: new Date().toISOString()
        }
      ];

      // Add graduation note if applicable
      if (examType === '科目四' && result === 'passed') {
        notes.push({
          content: `${username} 更新学员状态为「已毕业」`,
          date: new Date().toISOString()
        });
      }

      const existingNotes = studentObj.get('notes') || [];
      studentObj.set('notes', [...existingNotes, ...notes]);

      await Promise.all([exam.save(), studentObj.save()]);
      return true;
    } catch (error) {
      console.error('Edit result error:', error);
      throw error;
    }
  },

  async submitResults(examId, results) {
    try {
      const examQuery = new AV.Query('ExamBooking');
      const exam = await examQuery.get(examId);
      
      const students = exam.get('students');
      let passedCount = 0;
      
      const updatedStudents = students.map(student => {
        const result = results[student.studentId];
        if (result) {
          if (result === 'passed') passedCount++;
          return {
            ...student,
            result,
            status: result
          };
        }
        return student;
      });

      exam.set('students', updatedStudents);
      exam.set('passedCount', passedCount);

      // Update each student's record
      const studentUpdates = Object.entries(results).map(async ([studentId, result]) => {
        const studentQuery = new AV.Query('Student');
        const student = await studentQuery.get(studentId);
        
        const examType = exam.get('examType');
        const examNumber = examType.slice(-1);
        const examField = `exam${examNumber}`;
        const examCompletedField = `subject${examNumber}Completed`;
        
        student.set(examField, {
          passed: result === 'passed',
          date: dayjs(exam.get('date')).format('YYYY-MM-DD')
        });
        
        student.set(examCompletedField, result === 'passed');

        // Update student status to graduated if passed 科目四
        if (examType === '科目四' && result === 'passed') {
          student.set('status', '已毕业');
          student.set('graduateDate', new Date());
        }

        // Add notes
        const currentUser = AV.User.current();
        const username = currentUser ? currentUser.get('username') : '未知用户';
        const resultText = {
          'passed': '通过',
          'failed': '未通过',
          'absent': '缺考'
        }[result] || result;

        const notes = [
          {
            content: `${username} 更新了 ${examType}考试结果 为 「${resultText}」`,
            date: new Date().toISOString()
          }
        ];

        // Add graduation note if applicable
        if (examType === '科目四' && result === 'passed') {
          notes.push({
            content: `${username} 更新学员状态为「已毕业」`,
            date: new Date().toISOString()
          });
        }

        const existingNotes = student.get('notes') || [];
        student.set('notes', [...existingNotes, ...notes]);
        
        return student.save();
      });

      await Promise.all([exam.save(), ...studentUpdates]);

      await activityLogService.logActivity(
        '提交考试结果',
        `提交${exam.get('examType')}考试结果，通过: ${passedCount}人，总计: ${results.length}人`
      );

      return true;
    } catch (error) {
      console.error('Submit results error:', error);
      throw error;
    }
  },

  async createExam(examData) {
    try {
      const ExamBooking = AV.Object.extend('ExamBooking');
      const booking = new ExamBooking();

      // Set basic booking info
      booking.set('date', new Date(examData.date));
      booking.set('examType', examData.exam);
      booking.set('examiner', examData.examiner);
      booking.set('status', 'pending');
      booking.set('createdBy', AV.User.current());
      
      // Set students info
      const students = examData.students.map(student => ({
        studentId: student.objectId,
        name: student.name,
        fileId: student.fileId,
        uniqueId: student.uniqueId,
        phone: student.phone,
        result: null,
        status: 'pending'
      }));
      booking.set('students', students);
      
      // Set counts
      booking.set('totalCount', students.length);
      booking.set('completedCount', 0);
      booking.set('passedCount', 0);

      // Save booking
      const savedBooking = await booking.save(null, { useMasterKey: true });
      
      await activityLogService.logActivity(
        '创建考试',
        `创建${examData.exam}考试，考官: ${examData.examiner}，考试日期: ${examData.date}`
      );
      
      return savedBooking.toJSON();
    } catch (error) {
      console.error('Create exam error:', error);
      throw error;
    }
  },

  async importStudyProgress(file) {
    try {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async (e) => {
          try {
            console.log('Starting to process Excel file...');
            const workbook = XLSX.read(e.target.result, { type: 'array' });
            console.log('Workbook loaded, sheets:', workbook.SheetNames);

            const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
            console.log(`Total rows found (including header): ${rows.length}`);
            
            // Skip the header row
            const dataRows = rows.slice(1);
            console.log(`Processing ${dataRows.length} data rows`);
            
            let processedCount = 0;
            let successCount = 0;
            let errorCount = 0;
            const failedRecords = []; // Array to store failed records

            // Process each row
            for (const [index, row] of dataRows.entries()) {
              try {
                const uniqueId = row[1];  // Column B
                const subjectText = row[3];  // Column D
                const kilometers = parseFloat(row[5]) || 0;  // Column F
                const classroomMinutes = parseFloat(row[6]) || 0;  // Column G
                const practiceMinutes = parseFloat(row[7]) || 0;  // Column H
                const status = row[15];  // Column P

                console.log(`Processing row ${index + 2}:`, {
                  uniqueId,
                  subjectText,
                  kilometers,
                  classroomMinutes,
                  practiceMinutes,
                  status
                });

                // Skip if not approved
                if (status !== '通过') {
                  console.log(`Skipping row ${index + 2}: Status not '通过' (${status})`);
                  failedRecords.push({
                    row: index + 2,
                    uniqueId,
                    reason: `状态不是"通过"(${status})`
                  });
                  continue;
                }

                // Map subject text to number
                const subjectMap = {
                  '第一部分': '科目一',
                  '第二部分': '科目二',
                  '第三部分': '科目三',
                  '第四部分': '科目四'
                };
                const subject = subjectMap[subjectText];
                if (!subject) {
                  console.log(`Skipping row ${index + 2}: Invalid subject text (${subjectText})`);
                  failedRecords.push({
                    row: index + 2,
                    uniqueId,
                    reason: `无效的科目名称(${subjectText})`
                  });
                  continue;
                }

                // Query student by uniqueId
                console.log(`Querying student with uniqueId: ${uniqueId}`);
                const query = new AV.Query('Student');
                query.equalTo('uniqueId', uniqueId);
                const student = await query.first();
                
                if (!student) {
                  console.log(`Student not found for uniqueId: ${uniqueId}`);
                  failedRecords.push({
                    row: index + 2,
                    uniqueId,
                    reason: '身份证号未找到'
                  });
                  errorCount++;
                  continue;
                }

                console.log(`Found student: ${student.get('name')}`);

                // Update study hours based on subject
                if (subject === '科目二' || subject === '科目三') {
                  console.log(`Updating ${subject} with practice minutes: ${practiceMinutes}, kilometers: ${kilometers}`);
                  await this.updateStudyHours(
                    [student.id],
                    subject,
                    practiceMinutes,
                    kilometers
                  );
                } else {
                  console.log(`Updating ${subject} with classroom minutes: ${classroomMinutes}`);
                  await this.updateStudyHours(
                    [student.id],
                    subject,
                    classroomMinutes
                  );
                }
                
                successCount++;
              } catch (rowError) {
                console.error(`Error processing row ${index + 2}:`, rowError);
                failedRecords.push({
                  row: index + 2,
                  uniqueId: row[1],
                  reason: rowError.message
                });
                errorCount++;
              }
              processedCount++;
            }

            console.log('Import completed:', {
              totalRows: dataRows.length,
              processed: processedCount,
              successful: successCount,
              errors: errorCount,
              failedRecords
            });

            resolve({
              success: true,
              stats: {
                total: dataRows.length,
                processed: processedCount,
                successful: successCount,
                errors: errorCount
              },
              failedRecords // Return failed records to component
            });
          } catch (error) {
            console.error('Excel processing error:', error);
            reject(error);
          }
        };
        reader.onerror = (error) => {
          console.error('File reading error:', error);
          reject(error);
        };
        reader.readAsArrayBuffer(file);
      });
    } catch (error) {
      console.error('Import study progress error:', error);
      throw error;
    }
  },

  // Add this new method to examService
  async cancelExam(examId) {
    try {
      const examQuery = new AV.Query('ExamBooking');
      const exam = await examQuery.get(examId);
      
      // Check if exam can be cancelled (you might want to add more conditions)
      const examDate = dayjs(exam.get('date'));
      if (examDate.isBefore(dayjs(), 'day')) {
        throw new Error('无法取消已过期的考试预约');
      }

      // Log the cancellation activity
      await activityLogService.logActivity(
        '取消考试',
        `取消${exam.get('examType')}考试，考官: ${exam.get('examiner')}，考试日期: ${exam.get('date')}`
      );

      // Delete the exam booking
      await exam.destroy({ useMasterKey: true });
      
      return true;
    } catch (error) {
      console.error('Cancel exam error:', error);
      throw error;
    }
  },

  // Add a new method to get all students with qualification status
  async getAllStudentsWithQualification(examType, examDate) {
    try {
      console.log(`Fetching all students for ${examType} on ${examDate}`);
      
      // We'll use batching to get all students
      const batchSize = 500;
      let allStudents = [];
      let hasMore = true;
      let skip = 0;
      
      // Setup basic query parameters
      const createQuery = () => {
        const query = new AV.Query('Student');
        query.equalTo('status', '正常');
        query.equalTo('verified', true);
        
        // Exclude students who have already passed this exam
        // Use the specific exam field based on exam type
        switch(examType) {
          case '科目一':
            query.doesNotExist('exam1');
            // Or exam1.passed is false
            const failedExam1Query = new AV.Query('Student')
              .exists('exam1')
              .equalTo('exam1.passed', false);
            return AV.Query.or(query, failedExam1Query);
          case '科目二':
            query.doesNotExist('exam2');
            // Or exam2.passed is false
            const failedExam2Query = new AV.Query('Student')
              .exists('exam2')
              .equalTo('exam2.passed', false);
            return AV.Query.or(query, failedExam2Query);
          case '科目三':
            query.doesNotExist('exam3');
            // Or exam3.passed is false
            const failedExam3Query = new AV.Query('Student')
              .exists('exam3')
              .equalTo('exam3.passed', false);
            return AV.Query.or(query, failedExam3Query);
          case '科目四':
            query.doesNotExist('exam4');
            // Or exam4.passed is false
            const failedExam4Query = new AV.Query('Student')
              .exists('exam4')
              .equalTo('exam4.passed', false);
            return AV.Query.or(query, failedExam4Query);
          default:
            return query;
        }
      };
      
      // Fetch students in batches until we've got them all
      while (hasMore) {
        const query = createQuery();
        
        // Include necessary fields
        query.include('receiptPic');
        query.include('tuitionReceipt');
        query.include('withdrawReceipt');
        
        // Add sorting
        query.addDescending('VIP');
        query.addAscending('signUpDate');
        
        // Apply pagination
        query.limit(batchSize);
        query.skip(skip);
        
        // Execute query
        const students = await query.find();
        console.log(`Fetched batch of ${students.length} students (skip: ${skip})`);
        
        if (students.length > 0) {
          allStudents = allStudents.concat(students);
          skip += students.length;
        }
        
        // If we got fewer results than the batch size, we're done
        if (students.length < batchSize) {
          hasMore = false;
        }
      }
      
      console.log(`Found ${allStudents.length} total students`);
      
      // Map students and check qualification for each
      return allStudents.map(student => {
        // Debug log to verify the correct data structure is being passed
        console.log('Processing student:', student.get('name'));
        console.log('Student exams array:', student.get('exams'));
        
        const studentObj = {
          objectId: student.id,
          fileId: student.get('fileId'),
          name: student.get('name'),
          uniqueId: student.get('uniqueId'),
          phone: student.get('phone'),
          signUpDate: student.get('signUpDate'),
          VIP: student.get('VIP'),
          address: student.get('address'),
          tuitionFee: student.get('tuitionFee'),
          referrer: student.get('referrer'),
          notes: student.get('notes'),
          verified: student.get('verified'),
          documented: student.get('documented'),
          status: student.get('status'),
          subject1Completed: student.get('subject1Completed'),
          subject2Completed: student.get('subject2Completed'),
          subject3Completed: student.get('subject3Completed'),
          subject4Completed: student.get('subject4Completed'),
          exam1: student.get('exam1'),
          exam2: student.get('exam2'),
          exam3: student.get('exam3'),
          exam4: student.get('exam4'),
          exams: student.get('exams'), // Make sure this is being passed correctly
          ethnicity: student.get('ethnicity'),
          birthday: student.get('birthday'),
          local: student.get('local'),
          interviewed: student.get('interviewed'),
          transferred: student.get('transferred'),
          paid: student.get('paid'),
          paymentMethod: student.get('paymentMethod'),
          receiptNumber: student.get('receiptNumber'),
          receiptPic: student.get('receiptPic'),
          tuitionReceipt: student.get('tuitionReceipt'),
          gender: student.get('gender'),
          studyProgress: student.get('studyProgress'),
          withdrawDate: student.get('withdrawDate'),
          withdrawReason: student.get('withdrawReason'),
          withdrawReceipt: student.get('withdrawReceipt')
        };
        
        // Log the final student object to verify 'exams' is properly included
        console.log('Final student object contains exams?', !!studentObj.exams);
        if (studentObj.exams) {
          console.log('Exams array in final object:', studentObj.exams);
        }
        
        // Check qualification
        const { qualified, errors } = this.checkStudentQualification(studentObj, examType, examDate);
        
        // Add qualification status and errors to the student object
        return {
          ...studentObj,
          qualified,
          errors
        };
      });
    } catch (error) {
      console.error('Get all students with qualification error:', error);
      throw error;
    }
  },
}; 